import React from 'react';
import styles from './Title.module.scss';
import cn from "classnames";

interface TitleProps {
    title: string;
    titleShadow: string;
    className: string;
    size?: string;
    duo?: boolean;
}

const Title: React.FC<TitleProps> = ({title, titleShadow, className, size, duo}) => {
    return (
        <div className={cn(styles.wrapper, size ? styles[size] : undefined, styles[className])}>
            <p className={styles.shadow}>{titleShadow}</p>
            <p className={cn(styles.title, duo ? styles.duo : undefined)}>{title}</p>
        </div>
    )
}

export default Title;